import React from 'react';
import { Tooltip } from 'antd';

export const PROPOSAL_STATUS_CONSTANT = {
  LOGIN_WIP_PROPOSAL_DRAFT: "Login WIP - Proposal Draft",
  LOGIN_WIP_OTP_AUTHENTICATION_PENDING: "Login WIP - OTP Authentication pending",
  SUPERVISOR_APPROVAL_PENDING: "Supervisor Approval Pending",
  LOGIN_WIP_PAYMENT_PENDING: "Login WIP - Payment Pending",
  LOGIN_WIP_MANDATE_PENDING: "Login WIP - Mandate Pending",
  LOGIN_WIP_ESIR_PENDING: "Login WIP - e-SIR Pending",
  LOGIN_SUCCESSFUL: "Login successful - Login Successful",
  RTS_PENDING: "RTS Pending",
  RTS_SUBMITTED: "RTS Submitted",
  // DECLINED : "Contract Declined"
};

export const POLICY_STATUS_CONSTANT = {
  BLANK: "Blank",
  NA: "NA",
  NO_POLICY_MAPPED: "No policy is mapped with this proposal number.",
  IN_FORCE: "In Force",
  CONTRACT_PROPOSAL: "Contract Proposal",
  // RTS_CONTRACT_PROPOSAL: "Contract Proposal",
  DECLINED: "Contract Declined",
  WITHDRAWN: "Contract Withdrawn",
  POSTPONED: "Contract Postponed",
  REJECTED: "Contract Rejected",
  CANCELLED_FOR_INCEPTION: "Cancelled from Inception",
  FREE_LOOK: "Free Look",
};

export const ProposalStatusCheck = (item) => {
  const proposalStatus = item?.proposalStatus;

  // Treating policyStatus as "Blank" if it's missing or undefined
  const policyStatus = item?.policyStatus?.PolicyStatus?.stage || item?.policyStatus?.PolicyStatus || POLICY_STATUS_CONSTANT.BLANK;

  // Using a combination of proposalStatus and policyStatus to determine Display Status
  switch (proposalStatus) {
    case PROPOSAL_STATUS_CONSTANT.LOGIN_WIP_PROPOSAL_DRAFT:
      if (policyStatus === POLICY_STATUS_CONSTANT.BLANK) {
        return "Login WIP - Proposal Draft";
      }
      break;

    case PROPOSAL_STATUS_CONSTANT.LOGIN_WIP_OTP_AUTHENTICATION_PENDING:
      if (policyStatus === POLICY_STATUS_CONSTANT.BLANK) {
        return "Login WIP - OTP Authentication Pending";
      }
      break;

    case PROPOSAL_STATUS_CONSTANT.SUPERVISOR_APPROVAL_PENDING:
      if (policyStatus === POLICY_STATUS_CONSTANT.BLANK) {
        return "Supervisor Approval Pending";
      }
      break;

    case PROPOSAL_STATUS_CONSTANT.LOGIN_WIP_PAYMENT_PENDING:
      if (policyStatus === POLICY_STATUS_CONSTANT.BLANK) {
        return "Login WIP - Payment Pending";
      }
      break;

    case PROPOSAL_STATUS_CONSTANT.LOGIN_WIP_MANDATE_PENDING:
      if (policyStatus === POLICY_STATUS_CONSTANT.BLANK) {
        return "Login WIP - Mandate Pending";
      }
      break;

    case PROPOSAL_STATUS_CONSTANT.LOGIN_WIP_ESIR_PENDING:
      if (policyStatus === POLICY_STATUS_CONSTANT.BLANK) {
        return "Login WIP - e-SIR Pending";
      }
      break;

    case PROPOSAL_STATUS_CONSTANT.LOGIN_SUCCESSFUL:
      switch (policyStatus) {
        case POLICY_STATUS_CONSTANT.BLANK:
        case POLICY_STATUS_CONSTANT.NA:
        case POLICY_STATUS_CONSTANT.NO_POLICY_MAPPED:
          return "Login Successful";
        case POLICY_STATUS_CONSTANT.IN_FORCE:
          return "Issued";
        case POLICY_STATUS_CONSTANT.CONTRACT_PROPOSAL:
          return "Contract Proposal";
        case POLICY_STATUS_CONSTANT.DECLINED:
          return "Contract Declined";
        case POLICY_STATUS_CONSTANT.WITHDRAWN:
          return "Contract Withdrawn";
        case POLICY_STATUS_CONSTANT.POSTPONED:
          return "Contract Postponed";
        case POLICY_STATUS_CONSTANT.REJECTED:
          return "Contract Rejected";
        case POLICY_STATUS_CONSTANT.CANCELLED_FOR_INCEPTION:
          return "Cancelled from Inception";
        case POLICY_STATUS_CONSTANT.FREE_LOOK:
          return "Free Look";
        default:
          return "Unknown Status";
      }

    case PROPOSAL_STATUS_CONSTANT.RTS_PENDING:
      switch (policyStatus) {
        case POLICY_STATUS_CONSTANT.CONTRACT_PROPOSAL:
          return "RTS Pending";
        case POLICY_STATUS_CONSTANT.IN_FORCE:
          return "RTS Submitted";
        case POLICY_STATUS_CONSTANT.DECLINED:
          return "Contract Declined";
        case POLICY_STATUS_CONSTANT.WITHDRAWN:
          return "Contract Withdrawn";
        case POLICY_STATUS_CONSTANT.REJECTED:
          return "Contract Rejected";
        case POLICY_STATUS_CONSTANT.CANCELLED_FOR_INCEPTION:
          return "Cancelled from Inception";
        case POLICY_STATUS_CONSTANT.FREE_LOOK:
          return "RTS Pending";
        case POLICY_STATUS_CONSTANT.POSTPONED:
          return "Contract Postponed";

        default:
          return "Unknown Status";
      }

    case PROPOSAL_STATUS_CONSTANT.RTS_SUBMITTED:
      switch (policyStatus) {
        case POLICY_STATUS_CONSTANT.CONTRACT_PROPOSAL:
          return "RTS Submitted";
        case POLICY_STATUS_CONSTANT.IN_FORCE:
          return "RTS Submitted";
        case POLICY_STATUS_CONSTANT.DECLINED:
          return "Contract Declined";
        case POLICY_STATUS_CONSTANT.WITHDRAWN:
          return "Contract Withdrawn";
        case POLICY_STATUS_CONSTANT.REJECTED:
          return "Contract Rejected";
        case POLICY_STATUS_CONSTANT.CANCELLED_FOR_INCEPTION:
          return "Cancelled from Inception";
        case POLICY_STATUS_CONSTANT.FREE_LOOK:
          return "Free Look";
        case POLICY_STATUS_CONSTANT.POSTPONED:
          return "Contract Postponed";
        case POLICY_STATUS_CONSTANT.REJECTED:
          return "Contract Rejected";
        default:
          return "Unknown Status";
      }

    default:
      return "Unknown Status";
  }
};

// Parent function to get policy number based on the ProposalStatusCheck result
export const getPolicyNumberFromStatus = (item) => {
  try {
    const proposalStatusMessage = ProposalStatusCheck(item); // If ProposalStatusCheck is async
    const policyNum = item?.policyStatus?.PolicyStatus?.policyNo || "";
    console.log("proposalStatusMessage--114>>", proposalStatusMessage);
    console.log("policyNum--114>>", policyNum);
    switch (proposalStatusMessage) {
      case "Login WIP - Proposal Draft":
      case "Login WIP - OTP Authentication Pending":
      case "Login WIP - Payment Pending":
      case "Login WIP - Mandate Pending":
      case "Login WIP - e-SIR Pending":
      case "Supervisor Approval Pending":
        return "";

      case "Login Successful":
        if (item?.policyStatus?.PolicyStatus?.stage === POLICY_STATUS_CONSTANT.IN_FORCE) {
          return policyNum;
        }
        return "";

      case "Issued":
      case "Contract Proposal":
      case "Free Look":
      case "RTS Pending":
      case "RTS Submitted":
      case "Contract Declined":
      case "Contract Withdrawn":
      case "Contract Postponed":
      case "Rejected":
      case "Cancelled from Inception":
        return policyNum;

      default:
        return "";
    }
  } catch (error) {
    console.error("Error in getPolicyNumberFromStatus:", error);
    return "";
  }
};

// Function to render Medical Test Status based on proposal status and medical test data
export const renderMedicalTestStatus = (item, medicalTestMaster) => {
  const proposalStatus = item?.proposalStatus;
  const indCodes = item?.medicalApplicabilityDetails?.medicalTestsIndCodes || [];
  const pkgCodes = item?.medicalApplicabilityDetails?.medicalTestsPkgCodes || [];

  // handle combination codes like "UFR UDS UBL" for pkgcodes
  const processCodes = (codes) => codes.flatMap(code => (typeof code === 'string' ? code.trim().split(/\s+/) : code)).filter(Boolean);

  const combinedCodes = [...processCodes(indCodes), ...processCodes(pkgCodes)];
  const medicalTests = combinedCodes;
  const checkStatus = item?.medicalApplicabilityDetails?.checkStatus;

  if (checkStatus === "PENDING") {
    return "N/A";
  }

  if (medicalTests && checkStatus === "COMPLETED") {
    if (Array.isArray(medicalTests) && medicalTests.length === 0) {
      return "Not Required";
    } else if (Array.isArray(medicalTests)) {
      const tooltipContent = (
        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {medicalTests.map((code) => (
            <div key={code}>
              <b>{code}:</b> {medicalTestMaster?.[code] || "Medical Test"}
            </div>
          ))}
        </div>
      );
      return (
        <Tooltip title={tooltipContent} overlayStyle={{ maxWidth: '300px' }} placement="bottom">
          <span style={{ cursor: "pointer", textDecoration: "underline dotted", color: "#1A60BC" }}>
            Required: {medicalTests.join(", ")}
          </span>
        </Tooltip>
      );
    } else if (typeof medicalTests === "string" && medicalTests.trim() === "") {
      return "Not Required";
    } else {
      return medicalTests.toString();
    }
  }

  return "N/A";
};
